var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"us-faq"},[_c('faq-section',{attrs:{"questions":_vm.questions,"padding":30}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }